import React, { useState, useEffect, useCallback } from 'react';
import { talukaAPI } from '../../services/api';

// Helper to mask phone number
function maskPhone(phone) {
  if (!phone) return '—';
  const str = String(phone).replace(/\D/g, '');
  if (str.length < 4) return '***';
  return '*'.repeat(str.length - 4) + str.slice(-4);
}

export default function TalukaStaff() {
  const [staff, setStaff]   = useState([]);
  const [gps, setGps]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);
  const [page, setPage]     = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({ tenant_id: '', department: '', search: '' });

  const load = useCallback(async () => {
    try {
      setLoading(true); setError(null);
      const [sRes, gRes] = await Promise.all([
        talukaAPI.getStaff({ page, limit: 20, ...filters }),
        gps.length === 0 ? talukaAPI.getGrampanchayats() : Promise.resolve({ data: { grampanchayats: gps } })
      ]);
      const d = sRes.data?.staff || sRes.data?.data || sRes.data || {};
      setStaff(Array.isArray(d) ? d : []);
      setTotalPages(sRes.data?.pagination?.totalPages || Math.ceil((sRes.data?.pagination?.total || 1) / 20) || 1);
      if (gps.length === 0) setGps(gRes.data?.grampanchayats || gRes.data?.data || gRes.data || []);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load staff');
    } finally { setLoading(false); }
  }, [page, filters]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);
  const setF = (key, val) => { setFilters(f => ({ ...f, [key]: val })); setPage(1); };

  return (
    <div>
      <div className="tk-page-header">
        <h1>Staff Directory</h1>
        <p>All Grampanchayat staff and employees across the taluka</p>
      </div>
      <div className="tk-filter-bar">
        <input placeholder="Search name, designation…" value={filters.search} onChange={e => setF('search', e.target.value)} />
        <select value={filters.tenant_id} onChange={e => setF('tenant_id', e.target.value)}>
          <option value="">All GPs</option>
          {gps.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
        </select>
        <input placeholder="Department…" value={filters.department} onChange={e => setF('department', e.target.value)} />
      </div>
      {loading && <div style={{ textAlign: 'center', padding: 40 }}>Loading…</div>}
      {error   && <div style={{ textAlign: 'center', padding: 40, color: '#c62828' }}>{error}</div>}
      {!loading && !error && (
        <>
          <div className="tk-card">
            <div className="tk-table-wrap">
              <table className="tk-table">
                <thead>
                  <tr><th>Name</th><th>Designation</th><th>Department</th><th>Employee ID</th><th>Mobile</th><th>Grampanchayat</th><th>Status</th></tr>
                </thead>
                <tbody>
                  {staff.map((s, i) => (
                    <tr key={s.id || i}>
                      <td><strong>{s.first_name || s.name || '—'} {s.last_name || ''}</strong></td>
                      <td>{s.designation || '—'}</td>
                      <td>{s.department || '—'}</td>
                      <td style={{ fontFamily: 'monospace' }}>{s.employee_id || '—'}</td>
                      <td style={{ fontFamily: 'monospace' }}>{maskPhone(s.mobile_number)}</td>
                      <td><strong>{s.grampanchayat?.name || s.gp_name || s.Tenant?.name || '—'}</strong></td>
                      <td><span className={`tk-badge ${s.is_active ? 'tk-badge-active' : 'tk-badge-inactive'}`}>{s.is_active ? 'Active' : 'Inactive'}</span></td>
                    </tr>
                  ))}
                  {staff.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', padding: 24, color: '#aaa' }}>No staff found</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
          <div className="tk-pagination">
            <button onClick={() => setPage(p => p - 1)} disabled={page <= 1}>← Prev</button>
            <span style={{ fontSize: '0.85rem', color: '#555' }}>Page {page} of {totalPages}</span>
            <button onClick={() => setPage(p => p + 1)} disabled={page >= totalPages}>Next →</button>
          </div>
        </>
      )}
    </div>
  );
}
